import { render } from "./AllQueries.vue?vue&type=template&id=d98bcca4&scoped=true&ts=true"
import script from "./AllQueries.vue?vue&type=script&lang=ts"
export * from "./AllQueries.vue?vue&type=script&lang=ts"

import "./AllQueries.vue?vue&type=style&index=0&id=d98bcca4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98bcca4"]])

export default __exports__